import { PayCycle, SavingsPlanEntry } from '@aslanpay/portal-common-lib';

export interface PlanEntryWithCycle extends SavingsPlanEntry {
  payCycle?: PayCycle;
}

export interface GroupedPlanEntries {
  past: PlanEntryWithCycle[];
  current: PlanEntryWithCycle[];
  future: PlanEntryWithCycle[];
}

const toDay = (value: string) => value.slice(0, 10);

const groupPlanEntries = (
  entries: SavingsPlanEntry[],
  payCycles: PayCycle[],
  today: string
): GroupedPlanEntries => {
  const day = toDay(today);
  const payCycleById = new Map(payCycles.map((payCycle) => [payCycle.id, payCycle]));
  const currentPayCycle = payCycles.find(
    (payCycle) => toDay(payCycle.startDate) <= day && day <= toDay(payCycle.endDate)
  );

  return entries.reduce<GroupedPlanEntries>(
    (groups, entry) => {
      const payCycle = payCycleById.get(entry.savingPayCycleId);
      const withCycle = { ...entry, payCycle };

      if (payCycle && currentPayCycle) {
        if (payCycle.id === currentPayCycle.id) {
          groups.current.push(withCycle);
        } else if (toDay(payCycle.startDate) < toDay(currentPayCycle.startDate)) {
          groups.past.push(withCycle);
        } else {
          groups.future.push(withCycle);
        }
      } else if (entry.isProjection) {
        groups.future.push(withCycle);
      } else {
        groups.past.push(withCycle);
      }

      return groups;
    },
    { past: [], current: [], future: [] }
  );
};

export default groupPlanEntries;
